<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/task/table">任务列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-tabs v-model="currentTab">
        <el-tab-pane label="任务配置"
                     name="first">
          <task-form v-model="form"
                     ref="taskForm" />
        </el-tab-pane>
        <el-tab-pane label="多门店定价列表"
                     name="second"
                     :disabled="!showCitySalaryTable">
          <city-salary-table :table="cityTable"
                             @submitTask="submitTask" />
        </el-tab-pane>
      </el-tabs>
    </layout-panel>
  </div>
</template>

<script>
import TaskForm from '../components/TaskForm'
import CitySalaryTable from '../components/CitySalaryTable'

export default {
  components: {TaskForm, CitySalaryTable},
  provide: function () {
    return {
      taskForm: this,
    }
  },
  watch: {
    'form.projectid' (id) {
      if (id) {
        request.common('getProjectDetail', {id}).then(({data}) => {
          let project = data
          request.common('getProjectFrozenAmount', {
            projectid: id,
            customerid: this.form.customerid,
          }).then(({data}) => {
            this.projectRemainAmount = _.round(project.budget - project.projectcost - data, 2)
          })
        })
      }
    },
  },
  data () {
    return {
      form: {},
      sourceData: [], // 原表格中的原始数据
      showCitySalaryTable: false,
      currentTab: 'first',
      cityTable: [],
      projectRemainAmount: 0,
      taskAreaType: 1,
      nationalTaskParams: null,
      id: 0,
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onLoad()
    next()
  },
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    setForm (id) {
      request.page('getMiddleEndAudit', {id}).then(({data}) => {
        this.id = data.id
        filter.setLoop(this.form, data.detail.result.task_form)
        this.taskAreaType = data.detail.area_type
        this.form.taskAreaType = data.detail.area_type
        this.form.isEdit = true
        if (data.detail.result.city_table.length) {
          this.cityTable = data.detail.result.city_table
          this.showCitySalaryTable = true
        }
      })
    },
    submitTask (cityTable, totalSalary, taskCount) {
      this.$refs['taskForm'].$refs['form'].validate((valid, field) => {
        if (valid) {
          this.id ? this.update(this.id, cityTable, totalSalary, taskCount) : this.create(cityTable, totalSalary, taskCount)
        } else {
          let firstMsg = field[Object.keys(field)[0]][0]
          this.$message.error(firstMsg)

          this.switchTab('first')
          let $main = document.querySelector('#main')

          if ($main) {
            $main.scrollTop = 0
          }
        }
      })
    },
    create (cityTable, totalSalary, taskCount) {
      let form = this.$refs['taskForm'].getForm()
      if (form.is_personnel === 0) {
        form.personnel_requirements = {}
      }
      let avgSalary = _.round(totalSalary / taskCount / form.hirenum, 2)
      this.$refs['taskForm'].checkTaskSalary(form, totalSalary).then(() => {
        request.common('validateAvgSalary', {
          projectid: this.form.projectid,
          avg_salary: avgSalary
        }).then((data) => {
          // 无需审批
          if (data.data || this.taskAreaType === 3) {
            request.common('createMiddleEndTask', {
              area_type: this.taskAreaType,
              source_data: this.sourceData,
              city_table: cityTable,
              task_form: form
            }).then(() => {
              this.$alert('创建中台任务成功，请在批量任务列表中查看进度', '提示', {type: 'success'}).then(() => {
                this.$confirm(this.$route.name + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
                  this.form.estimate_consume_mins = 1
                  this.form.templateid = ''
                  this.showCitySalaryTable = false
                  this.currentTab = 'first'
                  this.$refs['taskForm'].taskAreaType = 1
                }, () => {
                  this.$router.push({path: '/task/batch/table'})
                })
              })
            })
          } else {
            // 需要审批
            request.common('createMiddleEndAudit', {
              area_type: this.taskAreaType,
              city_table: cityTable,
              task_form: form,
              predict_total: totalSalary,
              source_data: this.sourceData,
              avg_salary: avgSalary
            }).then(() => {
              this.$alert('创建中台任务审批成功', '提示', {type: 'success'}).then(() => {
                this.$confirm(this.$route.name + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
                  this.form.estimate_consume_mins = 1
                  this.form.templateid = ''
                  this.showCitySalaryTable = false
                  this.currentTab = 'first'
                  this.$refs['taskForm'].taskAreaType = 1
                }, () => {
                  this.$router.push({path: '/task/table'})
                })
              })
            })
          }
        })
      })
    },
    update (id, cityTable, totalSalary, taskCount) {
      let form = this.$refs['taskForm'].getForm()
      if (form.is_personnel === 0) {
        form.personnel_requirements = {}
      }
      let avgSalary = _.round(totalSalary / taskCount / form.hirenum, 2)
      this.$refs['taskForm'].checkTaskSalary(form, totalSalary).then(() => {
        request.common('validateAvgSalary', {
          projectid: this.form.projectid,
          avg_salary: avgSalary
        }).then((data) => {
          // 无需审批
          if (data.data || this.taskAreaType === 3) {
            request.common('createMiddleEndTask', {
              area_type: this.taskAreaType,
              source_data: this.sourceData,
              city_table: cityTable,
              task_form: form,
              audit_id: id,
              predict_total: totalSalary,
              avg_salary: avgSalary,
            }).then(() => {
              this.$alert('创建中台任务成功，审批自动通过。请在批量任务列表中查看进度', '提示', {type: 'success'}).then(() => {
                this.$router.push({path: '/task/table'})
              })
            })
          } else {
            // 需要审批
            request.common('editMiddleEndAudit', {
              area_type: this.taskAreaType,
              city_table: cityTable,
              source_data: this.sourceData,
              task_form: form,
              predict_total: totalSalary,
              avg_salary: avgSalary,
              id: id
            }).then(() => {
              this.$alert('修改 中台任务审批成功', '提示', {type: 'success'}).then(() => {
                this.$confirm(this.$route.name + '成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
                  this.$router.push({path: '/task/table'})
                }, () => {
                })
              })
            })
          }
        })
      })
    },
    enableCitySalaryTable (enable) {
      this.showCitySalaryTable = !!enable
    },
    setCityTable (data) {
      this.cityTable = data
    },
    setSourceData (data) {
      this.sourceData = data
    },
    switchTab (tab) {
      this.currentTab = tab
    },
    confirmNationalTask (params) {
      this.nationalTaskParams = params
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/middle-end-task/pages/MiddleEndTaskForm.vue